import styled from "styled-components";
import { Button } from 'components/common'

export const BackButtons = styled(Button)`
border-radius: 56%;
width: 40px;
height: 40px;
`

export const SpanPageTitle = styled.span`
border-radius: 10px;
font-size: 20px;
line-height: 30px;
font-weight: bolder;
margin: 13px 12px!important;
`
export const SpanPageSubTitle = styled.span`
font-size: 15px;
font-weight: bold;
margin: 0px 12px ;
`
export const SpanItem= styled.span`
border-radius: 10px;
margin: 15px 0px!important;
font-size: 20px;
line-height: 30px;
font-weight: bolder;
color: ${({ theme }) => theme.colors.secondary};
 margin: 13px 0px!important;
`
export const SmallText= styled.span`
border-radius: 10px;
margin: 15px 0px!important;
font-size: 14px;
line-height: 30px;
font-weight: bold;
color:${({theme,isOk,isNok})=> {
  if(isOk)return '#00C853'
  else if(isNok)return'#D50000'
  else return theme.colors.secondary
}};
 margin: 13px 0px!important;

`
export  const SpanTitle = styled.span`
font-family: Roboto;
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 28px;
display: flex;
align-items: center;
text-align: center;
margin: 0px 0px 8px;
color: #303030;
`
export  const FlexSpaceBetween = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
width: 100%;
`
export const ModalContainer = styled.div`
  flex:1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`